(function () {
  function FaqAccordion({ faqs }) {
    const [openIndex, setOpenIndex] = React.useState(null);

    const toggle = (index) => {
      setOpenIndex(openIndex === index ? null : index);
    };

    return React.createElement(
      'div',
      { className: 'faq-accordion' },
      faqs.map((faq, index) =>
        React.createElement(
          'div',
          { key: index, className: 'faq-item' },
          React.createElement(
            'button',
            {
              onClick: () => toggle(index),
              className: `faq-question ${openIndex === index ? 'active' : ''}`,
            },
            faq.question
          ),
          React.createElement('div', {
            className: `faq-answer ${openIndex === index ? 'open' : ''}`,
            dangerouslySetInnerHTML: { __html: faq.answer }
          })
        )
      )
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    const root = document.getElementById('faq-root');
    if (!root) return;

    try {
      const faqs = JSON.parse(root.getAttribute('data-faqs'));
      ReactDOM.render(React.createElement(FaqAccordion, { faqs }), root);
    } catch (e) {
      console.error('Error parsing FAQ data:', e);
    }
  });
})();
